export default {
  Maintenance: {
    BODY: "We're beavering away in the background making some improvements. Sorry for any inconvenience caused!",
    CHECK_LATER: 'Please check back later. Thanks!',
    THANKS: 'Team Mayday',
  },
};
